// ----------------------------------------------------------------------
// <copyright file="Izenda.Portal.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Portal component
 */
!(function() {
  var React = require('react');
  var ReactDOM = require('react-dom');
  var AppGlobal = require('Izenda.AppGlobal');

  var Portal = React.createClass({
    componentDidMount: function() {
      this.renderOverlay();
    },

    componentDidUpdate: function() {
      this.renderOverlay();
    },

    renderOverlay: function() {
      var overlay = !this.props.children
        ? null
        : React.Children.only(this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        this.mountOverlayTarget();
        this.overlayInstance = ReactDOM.unstable_renderSubtreeIntoContainer(
          this, overlay, this.overlayTarget
        );
      } else {
        // Unrender if the component is null for transitions to null
        this.unrenderOverlay();
        this.unmountOverlayTarget();
      }
    },

    componentWillUnmount: function() {
      this.unrenderOverlay();
      this.unmountOverlayTarget();
    },


    mountOverlayTarget: function() {
      if (!this.overlayTarget) {
        this.overlayTarget = document.createElement('div');
        this.portalContainerNode = AppGlobal.containerElement;
        this.portalContainerNode.appendChild(this.overlayTarget);
      }
    },

    unmountOverlayTarget: function() {
      if (this.overlayTarget) {
        this.portalContainerNode.removeChild(this.overlayTarget);
        this.overlayTarget = null;
      }
      this.portalContainerNode = null;
    },

    unrenderOverlay: function() {
      if (this.overlayTarget) {
        ReactDOM.unmountComponentAtNode(this.overlayTarget);
        this.overlayInstance = null;
      }
    },

    render: function() {
      return null;
    },

    getMountNode: function() {
      return this.overlayTarget;
    },

    getOverlayDOMNode: function() {
      if (!this.isMounted()) {
        return;
      }

      if (this.overlayInstance) {
        return ReactDOM.findDOMNode(this.overlayInstance);
      }

      return null;
    }
  });

  module.exports = Portal;
}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.Portal.jsx